import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { BaseComponent } from '../../../../base/base.component';
import { PageHeaderComponent } from '../../../../core/labels/page-header.component';
import { TabPanelComponent } from '../../../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../../../core/panels/tab-panel/tab.component';
import { CasualtyComponent } from '../casualty/casualty.component';
import { FieldInspectionPrComponent } from './field-inspection-pr.component';
import { LossStatementPrComponent } from './loss-statement-pr.component';
import { PropertyPrComponent } from './property-pr.component';

@Component({
  selector: 'app-property',
  imports: [
    PageHeaderComponent,
    TabPanelComponent,
    TabComponent,
    CasualtyComponent,
    PropertyPrComponent,
    LossStatementPrComponent,
    FieldInspectionPrComponent,
  ],
  template: `
    <app-page-header label="Property" />
    <app-tab-panel>
      <app-tab label="Event">
        <ng-template #content> <app-casualty /> </ng-template>
      </app-tab>
      @if (showDetailTabs) {
        <app-tab label="Property">
          <ng-template #content> <app-property-pr /> </ng-template>
        </app-tab>
        <app-tab label="Statement of loss">
          <ng-template #content> <app-loss-statement-pr /> </ng-template>
        </app-tab>
        <app-tab label="Field inspection">
          <ng-template #content> <app-field-inspection-pr /> </ng-template>
        </app-tab>
      }
    </app-tab-panel>
  `,
  styles: ``,
})
export class PropertyComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;
  showDetailTabs = false;

  ngOnInit(): void {
    this.claimRow = this.view.currentClaim();
    this.showDetailTabs = this.session.authorize('Property');
    this.view.hideLoading();
  }
}
